import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/ShieldCheck.es.js";
const o = e.forwardRef((c, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...c, weights: a }));
o.displayName = "ShieldCheckIcon";
const h = o;
export {
  h as ShieldCheck,
  o as ShieldCheckIcon
};
